module.exports = __webpack_public_path__ + "static/images/grab-app.1A6yKtm.svg";